import React, { forwardRef } from 'react'
import styled, { css } from 'styled-components'
import { STypographySmall } from '@components/Typography'
import Box from '@components/Box'
import { md } from '@styles/variables/breakpoints'
import { above } from '@styles/mixins/breakpoints'
import Item, { IItem } from '../Item'

const Container = styled(Box)`
  position: absolute;
  top: 40px;
  left: -20px;
  width: 100vw;
  height: 100vh;
  z-index: 1005;

  background-color: ${(props) => props.theme.colors.white};

  ${above(md)(css`
    height: auto;
    border-radius: ${(props) => props.theme.general.borderRadius};
    box-shadow: ${(props) => props.theme.general.boxShadow};
    width: 304px;
    max-height: 530px;
    left: -10px;
    top: calc(100% + 16px);
  `)}
`

interface IMenu {
  services: IItem[]
}

const Menu = forwardRef<HTMLDivElement, IMenu>(({ services }, ref) => {
  return (
    <Container ref={ref} display="flex" flexDirection="column" alignItems="center" px={{ _: 30, md: 20 }} pt={30}>
      <Box display="flex" flexWrap="wrap" justifyContent="center">
        {services.map((service) => (
          <Item {...service} key={service.text} />
        ))}
      </Box>
      <Box py="10px">
        <STypographySmall as="a" href="https://sber.ru" target="_blank">
          Больше об экосистеме Сбера &gt;
        </STypographySmall>
      </Box>
    </Container>
  )
})

Menu.displayName = 'EcosystemMenu'

export default Menu
